import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  effect,
  ElementRef,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  signal,
  TemplateRef
} from '@angular/core';
import {MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle} from '@angular/material/expansion';
import {MatFormField, MatPrefix} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR, ReactiveFormsModule} from '@angular/forms';
import {Observable, of} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {AsyncPipe, CommonModule} from '@angular/common';
import {MatIcon} from '@angular/material/icon';

@Component({
  selector: 'pas-experiment',
  standalone: true,
  imports: [
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatFormField,
    MatInput,
    AsyncPipe,
    ReactiveFormsModule,
    CommonModule,
    MatIcon,
    MatPrefix
  ],
  templateUrl: './experiment.component.html',
  styleUrl: './experiment.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ExperimentComponent), multi: true}
  ]
})
export class ExperimentComponent<T extends object> implements OnInit, OnDestroy, AfterViewInit, ControlValueAccessor {
  @Input() placeholder: string = '';

  _items: T[] | null = null
  @Input() set items(v: T[] | null) {
    this._items = v;
    this.filtredItems$ = this.form.get('search')!.valueChanges
      .pipe(startWith(''))
      .pipe(map(value => {
        if (!this._items || !this._items.length) return [];
        const res = this._items.filter(i => {
          return (JSON.stringify(i).toLowerCase().includes(value?.toLowerCase() || ''))
        }).filter(Boolean)
        // return res.length ? res: this._items ;
        return res;
      }));
  }

  get items(): T[] | null {
    return this._items;
  }

  @ContentChild('itemView', {read: TemplateRef}) itemView: TemplateRef<any> | null = null;

  currentItem = signal<T | null>(null);

  get value(): T | null {
    return this.currentItem();
  }

  set value(value: T | null) {
    this.currentItem.set(value)
    this.onChange(value);
    // if (value && ('name' in value)) this.form.get('search')?.setValue((value?.name+'')||'');
  }

  constructor(private elementRef: ElementRef) {
    this.onDocumentClick = this.onDocumentClick.bind(this);
    document.addEventListener('click', this.onDocumentClick, true);
  }

  onChange: (value: T | null) => void = () => {
  };
  onTouched: () => void = () => {
  };

  writeValue(obj: any): void {
    // this._value = obj;
    this.currentItem.set(obj);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // throw new Error('Method not implemented.');
  }


  expand = signal<boolean>(false);

  form = new FormGroup({
    search: new FormControl<string>('')
  })

  filtredItems$: Observable<T[]> = of(this.items || []);

  effectSelect = effect(() => {
    console.log('this.currentItem()', this.currentItem());
    this.value = this.currentItem();
    this.currentItem() && this.expand.set(false);
  }, {allowSignalWrites: true})

  onFocus($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
  }

  onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.expand.set(false);
    } else {
      return;
    }
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {

  }

  equalCurrentItem(i: T): boolean {
    return !!(this.currentItem() && JSON.stringify(this.currentItem()) === JSON.stringify(i));
  }

  ngOnDestroy(): void {
    document.removeEventListener('click', this.onDocumentClick);
  }

}
